<template>
  <div>
    <!-- Filters -->
    <cptu-list-filters
        :cptu-filter.sync="cptuStatusFilter"
        :cptu-status-options="cptuStatusOptions"
    />

    <!-- Table Container Card -->
    <b-card class="mb-0" no-body>
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
              cols="12"
              md="6"
          >
            <label>Affichage</label>
            <v-select
                v-model="perPage"
                :clearable="false"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                class="per-page-selector d-inline-block mx-50"
            />
            <label>CPTu</label>
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  placeholder="Rechercher..."
              />
              <b-button
                  variant="primary"
                  @click="openModal = !openModal"
              >
                <span class="text-nowrap">Importer CPTu </span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table
          ref="refCptuListTable"
          :fields="tableColumns"
          :items="fetchCptuList"
          :sort-by.sync="sortBy"
          :sort-desc.sync="isSortDirDesc"
          class="position-relative"
          empty-text="Pas de CPTu trouvé"
          primary-key="id"
          responsive
          show-empty
      >
        <!-- A virtual column -->
        <template #cell(index)="data">
          {{ data.index + 1 }}
        </template>

        <!-- Column: Status -->
        <template #cell(is_active)="data">
          <b-badge variant="light-primary" class="text-capitalize">
            {{ data.item.status }}
          </b-badge>
        </template>

        <!-- Column: Details -->
        <template #cell(details)="data">
          <b-button @click="toggleCptuDetails(data.item)" size="sm" variant="primary">
            <feather-icon icon="FileTextIcon" size="16"/>
          </b-button>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <div class="text-nowrap">
            <feather-icon
                :id="`cptu-row-${data.item.uid}-edit-icon`"
                class="cursor-pointer text-warning"
                icon="EditIcon"
                size="16"
                @click="
                $router.push({
                  name: 'apps-cptu-edit',
                  params: { id: data.item.uid }
                })
              "
            />
            <b-tooltip
                :target="`cptu-row-${data.item.uid}-edit-icon`"
                class="cursor-pointer"
                title="Modifier"
            />

            <feather-icon
                :id="`cptu-row-${data.item.uid}-delete-icon`"
                class="mx-1 text-danger"
                icon="TrashIcon"
                size="16"
                @click="deleteCptu(data.item.uid)"
            />
            <b-tooltip
                :target="`cptu-row-${data.item.uid}-delete-icon`"
                title="Supprimer"
            />
          </div>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
              cols="12"
              sm="6"
          >
            <span class="text-muted"
            >Affichage de {{ dataMeta.from }} à {{ dataMeta.to }} sur
              {{ dataMeta.of }} CPTu</span
            >
          </b-col>
          <!-- Pagination -->
          <b-col
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              cols="12"
              sm="6"
          >
            <b-pagination
                v-model="currentPage"
                :per-page="perPage"
                :total-rows="totalCptu"
                class="mb-0 mt-1 mt-sm-0"
                first-number
                last-number
                next-class="next-item"
                prev-class="prev-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18"/>
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18"/>
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>

    <cptu-import-modal :isOpened.sync="openModal" @upload-complete="refetchData"/>
    <cptu-modeler-details-modal
        :cptu-id="selectedCptuId"
        @hidden="selectedCptuId = null"
        :openModeler.sync="openModelerModal"
    />


  </div>
</template>

<script>
/* eslint-disable */
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormInput,
  BLink,
  BMedia,
  BPagination,
  BRow,
  BTable,
  BTooltip,
} from "bootstrap-vue";
import vSelect from "vue-select";
import CptuListFilters from "./CptuListFilters.vue";
import CptuImportModal from "@/views/apps/cptu/handle-cptu/CptuImportModal.vue";
import CptuModelerDetailsModal from "@/views/apps/cptu/cptu-list/CptuModelerDetailsModal.vue";
import useCptuList from "./useCptuList";
import {ref, watch} from "@vue/composition-api";

export default {
  name: "CptuList",
  components: {
    CptuListFilters,
    CptuImportModal,
    CptuModelerDetailsModal,

    BTooltip,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormCheckbox,

    vSelect,
  },
  setup() {
    const {
      fetchCptuList,
      tableColumns,
      perPage,
      currentPage,
      totalCptu,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refCptuListTable,
      refetchData,
      deleteCptu,

      // Extra Filters
      cptuStatusFilter,
      cptuStatusOptions,
    } = useCptuList();

    const openModal = ref(false)
    const openModelerModal = ref(false)
    const selectedCptuId = ref(null)

    const toggleCptuDetails = (cptu) => {
      selectedCptuId.value = cptu.uid
      openModelerModal.value = true
    }

    return {
      fetchCptuList,
      tableColumns,
      perPage,
      currentPage,
      totalCptu,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refCptuListTable,
      selectedCptuId,
      toggleCptuDetails,
      refetchData,
      deleteCptu,

      cptuStatusFilter,
      cptuStatusOptions,

      openModal,
      openModelerModal,
    };
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
